import React, {useState, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {FaIcon} from '../../FaIcon';
import {PromptModalityChoice} from '../../prompts/PromptModalityChoice';
import {PromptVersionBadge} from '../../prompts/PromptVersionBadge';
import {pingPromptCopied} from '../../prompts/promptCopyPing';
import {
    buildModalityOptions,
    defaultPromptMode,
    resolveActivePrompt,
} from '../../prompts/promptModalityOptions';

export function OfficialPromptsSection({prompts, copyStatus, onCopied}) {
    const {t} = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const [copied, setCopied] = useState(false);
    // Default derivado (stub si existe, si no ADDON) + elección explícita que lo pisa — mismo
    // patrón que PromptCopyBlock: los textos llegan de un fetch después del primer render.
    const [chosenMode, setChosenMode] = useState(null);
    const mode = chosenMode || defaultPromptMode(prompts);

    const showChoice = Boolean(prompts && (prompts.addon || prompts.stub));
    const active = resolveActivePrompt(mode, prompts);
    const activeText = active ? active.text : null;

    const handleCopy = useCallback(() => {
        if (!activeText) return;
        navigator.clipboard.writeText(activeText).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
            // Ping de copiado (fire-and-forget, patrón PromptLibraryCard): solo si la copia
            // ocurrió de verdad, con el id/versión de la modalidad ACTIVA.
            if (active.id) {
                pingPromptCopied(active.id, {version: active.version});
                if (onCopied) onCopied(active.id, active.version);
            }
        }).catch(() => {});
    }, [active, activeText, onCopied]);

    if (!prompts || !prompts.full || !prompts.full.text) return null;

    return (
        <div className="dashbo-mcp-section">
            <div className="prompt-collapsible">
                <button className="prompt-collapsible-toggle" onClick={() => setExpanded(!expanded)}>
                    <FaIcon iconName={expanded ? 'chevron-up' : 'chevron-down'}/>
                    {t('dashbo_mcp.prompts.title')}
                </button>
                {expanded && (
                    <div className="prompt-collapsible-body">
                        <p className="section-description">{t('dashbo_mcp.prompts.description')}</p>
                        {showChoice && (
                            <PromptModalityChoice
                                name="dashbo-mcp-official-prompt-mode"
                                question={t('dashbo_mcp.setup.modality_question')}
                                options={buildModalityOptions({t, prompts})}
                                value={mode}
                                onChange={setChosenMode}
                            />
                        )}
                        <pre className="prompt-text">{activeText}</pre>
                        <div className="prompt-actions">
                            {active && active.id && (
                                <PromptVersionBadge status={copyStatus && copyStatus[active.id]}/>
                            )}
                            <button className="btn -alt -negative" onClick={handleCopy}>
                                {copied ? t('dashbo_mcp.prompts.copied') : t('dashbo_mcp.prompts.copy')}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
